module.exports = __webpack_public_path__ + "static/img/icon_avatar.9ce23cdf.png";